import { Theme } from '@mui/material/styles'

export const required = (theme: Theme) => ({
  content: '"*"',
  color: theme.palette.error.main,
  display: 'inline',
})

export const sarabunFont = ({ size = 15, weight = '400' }) => ({
  fontFamily: 'Sarabun',
  fontStyle: 'normal',
  fontWeight: weight,
  fontSize: size,
})
